import {
  FETCH_ALL_ECOM_PRODUCT_CONTENT_LIST,
  FETCH_ALL_FILTER_PRODUCT_LIST,
  FETCH_ALL_MULTISLOT_CONTENT_LIST,
  FETCH_ALL_MULTISLOT_CONTENT_LIST_WITH_SORT_FILTER,
} from "../../graphQL/queries/contentGalleryQueries";

export const fetchAllFilterProductList = FETCH_ALL_FILTER_PRODUCT_LIST;
export const fetchAllMultislotContentList = FETCH_ALL_MULTISLOT_CONTENT_LIST;
export const fetchAllMultislotContentListWithSortFilter =
  FETCH_ALL_MULTISLOT_CONTENT_LIST_WITH_SORT_FILTER;
export const fetchAllEcomProductContentList = FETCH_ALL_ECOM_PRODUCT_CONTENT_LIST;
